import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';

import { IProprietarioVeiculo } from '../models/proprietario_veiculo.model';

type DeepPartial<T> = {
  [P in keyof T]?: DeepPartial<T[P]> | any[] | string | number | boolean;
};

export const mockActivatedRoute = (value: DeepPartial<ActivatedRoute>) => ({
  provide: ActivatedRoute,
  useValue: { ...value }
});

@Injectable()
export class ProprietarioVeiculoService extends EntityService<
  IProprietarioVeiculo
> {
  constructor(protected configService: ConfigService) {
    super(
      {
        urlBackend: configService.backendURL,
        baseEntityEndPoint: 'proprietario_veiculo'
      }
    );
  }
}
